// utils/simpleSecure.js

const SECRET_KEY = 'shi-yan' // 可以用 .env 配置

function hash (str) {
  // 原生 hash：简单加权求和（可替换为更复杂算法）
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0 // 转 32 位整数
  }
  return hash.toString()
}

export function encryptWithSignature (data, expiresInSeconds = 300) {
  const payload = {
    data,
    exp: Date.now() + expiresInSeconds * 1000
  }
  const json = JSON.stringify(payload)
  const signature = hash(json + SECRET_KEY)

  const wrapped = JSON.stringify({ payload, signature })
  return btoa(encodeURIComponent(wrapped))
}

export function decryptWithSignature (encoded) {
  try {
    const decoded = decodeURIComponent(atob(encoded))
    const { payload, signature } = JSON.parse(decoded)

    // 校验签名
    const validSig = hash(JSON.stringify(payload) + SECRET_KEY)
    if (signature !== validSig) {
      throw new Error('签名不匹配')
    }

    // 检查过期
    if (Date.now() > payload.exp) {
      throw new Error('已过期')
    }

    return payload.data
  } catch (e) {
    console.warn('参数解密失败:', e.message)
    return null
  }
}
